import React from 'react';

import { SvgIcon, SvgIconProps } from '@mui/material';

import { ReactComponent as Icon } from './Stroke2Icon.svg';

/**
 * @function
 * Auto-generated file.
 */
export const Stroke2Icon = React.forwardRef<SVGSVGElement, SvgIconProps>(function Stroke2Icon(props, ref) {
  return (
    <SvgIcon ref={ref} viewBox="0 0 16 12" component={Icon} {...props} />
  );
});
